<app-dialog
    [(visible)]="shareDialog"
    title="Share this thread"
    class="max-w-[36rem]"
    [showCloseButton]="true"
    (closed)="onCloseShareDialog()">

    <app-button
        dialogTrigger
        (clicked)="openShareDialog()"
        [enableThrottle]="true"
        variant="outlined"
        severity="contrast"
        pTooltip="Share"
        iconSource="lucide"
        icon="share-2" />

    <ng-template #bodyTemplate>
        <div class="flex flex-col mb-2">
            <div class="font-semibold text-md mb-1">Share URL</div>
            <div class="flex border px-2 py-1 gap-2 justify-between items-center rounded-base">
                <div class="underline overflow-x-scroll whitespace-nowrap no-scrollbar text-sm">
                    {{ shareUrl }}
                </div>
                <app-icon [type]="'pi pi-clone'" [source]="'primeng'" [size]="'default'"
                    (click)="copyShareUrlToClipboard()" />
            </div>
        </div>
        <app-share-to-users
            [threadId]="threadId()"
            [shareDetails]="shareDetails"
            (addUserToShare)="addUserToShare($event)"
            (removeUserFromShare)="removeUserFromShare($event)"
            (updateSharedUser)="updateSharedUser($event)" />
    </ng-template>
</app-dialog>
